<template>
  <div class="main">
    <div class="main--header">隐私政策</div>
    <div class="main--content">生效日期：2023年1月5日</div>
    <div class="main--content">更新日期：2023年1月5日</div>
    <div class="main--content">
      本《隐私政策》适用于 "杭州燃气"
      (下称“本产品”)服务，欢迎您使用本产品服务，本《隐私政策》将努力通过通俗易懂、简明扼要的文字表达，向您说明本产品在收集、使用、管理及保护您的个人信息方面的政策及措施，以及我们为您提供的访问、更新、删除和保护这些信息的方式。本《隐私政策》适用于本产品向您提供的服务，您具体获得的服务内容可能因为您使用的产品版本不同而有所差异。
      本产品运营方“杭州祺云科技有限公司”及其关联公司（以下简称“我们”），将按照法律法规的相关规定，保护您的个人信息。为保障您能更好地使用我们提供的服务，我们建议您认真阅读本《隐私政策》（尤其与您权益直接相关、涉及您个人敏感信息的加粗条款），并在确认充分理解后再决定是否使用我们向您提供的本产品服务，如有任何问题请于同意本政策前通过本政策提供的联系方式与我们取得联系。
    </div>
    <div>
      <div class="main--content--title">一、个人信息的收集</div>
      <div class="main--content--title">1.1您提供的或我们收集的信息</div>
      <div class="main--content">
        在您注册本产品账号或使用本产品提供的各项业务功能时，本产品将收集您提供的相关个人信息，在现有技术水平条件下，用以向您提供服务、提升我们的服务质量、保障您的账户安全及符合国家法律法规及监管规定：
      </div>
      <div class="main--content--title">（1）用户注册</div>
      <div class="main--content">
        您首先需要注册一个产品账号以成为本产品的用户，当您注册时，您需要至少向我们提供您准备使用的账户名、您创建的密码、您本人的手机号码，我们将通过发送短信验证码的方式来辅助验证您的身份。
        本为了您的便利，本产品允许您使用第三方账号进行注册、登录，如您选择使用第三方账号进行注册、登录（为此您必须保证该等第三方账号为您本人所有，且您享有对该等账号所含信息的充分处分权），您将授权我们获取并核实您在该第三方账号注册的信息。
      </div>
      <div class="main--content--title">（2）客服功能</div>
      <div class="main--content">
        当您与我们的客服取得联系时，我们的系统可能会记录您与客服之间的通讯记录。我们的客服基于核验您的身份需要，会使用您的账号信息。
      </div>
      <div class="main--content--title">
        （3）使用及改进我们的产品服务所必须的功能
      </div>
      <div class="main--content">
        为了更好地向您提供产品服务，我们会在您使用服务的过程中，搜集您的登录状态、服务使用数据、服务操作数据；并可向您本人或其他用户展示前述信息。为更好地改进我们的服务，我们将收集您使用服务中的日志信息（包括您发布的报错信息、反馈和评论的信息、您使用服务的时间信息）、使用记录信息、您通过本产品向其他方提供的共享信息、您对我们服务的意见、建议信息，您主动联系我们提交或反馈的信息；用于产品运营统计分析、产品改进计划。
      </div>
      <div class="main--content--title">（4）保障您的账户安全所必须的功能</div>
      <div class="main--content">
        为保障您使用本产品时的系统安全，我们可能会收集您的设备型号、IP地址、设备软件版本信息、设备识别码、设备标识符、所在地区、网络使用习惯、产品崩溃信息，并可能会记录一些我们认为有风险的链接信息；以进一步分析并排查可能存在的系统异常、系统风险，用于打击破坏产品公平环境或干扰、破坏产品服务正常进行的行为。
      </div>
      <div class="main--content--title">（5）互动功能</div>
      <div class="main--content">
        当您与产品其他用户进行互动、或主动发布信息时，我们可能会收集并保存您发送的相关信息内容。相关信息内容我们将按照法律法规政策及相关主管部门的要求进行不当内容过滤。
      </div>
      <div class="main--content--title">（6）申请注销您的账户。</div>
      <div class="main--content">
        在您主动向管理员申请注销账户之后，我们将在两小时内注销您的账号停止为您提供产品与/或服务，并根据适用法律的要求删除或匿名化处理您的个人信息。
      </div>
      <div class="main--content--title">1.2您授权我们收集和使用的个人信息</div>
      <div class="main--content--title">（1）设备权限</div>
      <div class="main--content">
        如您需要使用本产品的特定服务，或者为了拥有本产品更好的体验，您还将需要向我们提供特定业务功能所必需的信息，并允许我们调用您的必需设备权限，如存储、相机、相册等，在获取权限前我们会向您询问，您有权关闭权限。系统调取相机、相册，主要用于上传和修改个人头像，您有权拒绝。系统调取存储信息主要用于答题业务中临时信息的存储与记录。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。如您拒绝授权我们获取您的以上数据，可能会导致我们因未取得您的相关数据而无法向您提供某项服务；当相关数据为提供任一服务所必需的信息时，可能会导致我们因未取得您的相关数据而无法向您提供全部服务。
        应用中集成了com.igexin.sdk(个推;个推推送;) com.g.gysdk(个推)
        com.xiaomi.mipush(小米;小米推送) com.getui(个推;个数应用统计;个像)
        com.huawei.hms(华为;华为推送) com.huawei.agconnect(华为;华为联运应用)
        com.xiaomi.push(小米;小米推送)，都主要用于应用中系统消息的推送 ;
        应用集成了阿里云sdk，用于存储应用内图片视频资源
        应用获取用户的软件安装列表信息,判断本应用是否已安装在本机列表
      </div>
      <div class="main--content--title">（2） 第三方信息</div>
      <div class="main--content">
        为能向您提供更优质的服务，我们会在部分功能上使用第三方软件，以确保服务顺利完成，并为您更好地提供后续服务。
      </div>
      <div class="main--content">
        本应用中引用了第三方个推推送，会收集用户的账号信息，主要用于系统消息的推送。
      </div>
      <div class="main--content--title">（3） 网络访问权限</div>
      <div class="main--content">
        拥有网络访问权限，允许该应用创建网络套接字和使用自定义网络协议，浏览器和其他某些应用提供了向互联网发送数据的途径，因此应用无需该权限即可向互联网发送数据。目的用于用户正常使用软件功能。
      </div>
      <div class="main--content--title">（4） 音频设置权限</div>
      <div class="main--content">
        允许该应用修改全局音频设置，例如音量和用于输出的扬声器。
      </div>
      <div class="main--content--title">（5）获取定位权限</div>
      <div class="main--content">
        根据网络来源获取您的位置信息，您的手机必须支持并开启这些位置服务信息服务，才能有用。当您同意了请求，我们才能获取您的精准位置信息。
      </div>
      <div class="main--content--title">（6）检索正在运行的应用</div>
      <div class="main--content">
        经过您同意后，允许检索近期运行的和当前正在运行的任务相关信息。
      </div>
      <div class="main--content--title">（7）读取手机状态和身份</div>
      <div class="main--content">
        经过您同意后，允许访问设备的电话功能，此权限尽可确定本机号码和设备ID是否正处于通话状态以及拨打号码的状态。
      </div>
      <div class="main--content--title">（8）设备信息</div>
      <div class="main--content">
        在使用过程中获取您的设备信息、ANDROID
        ID，进行设备判断进行不同页面的跳转，并方便收集反馈兼容性问题。非凡科技深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠，我们致力于维持您对我们的信任。
      </div>
      <div class="main--content">
        设备信息：包括设备标识符（IMEI、IDFA、Android
        ID、MAC、OAID、IMSI及其他设备相关信息）、应用信息（应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息），设备网络环境信息（IP地址，WiFi信息，基站信息及其他网络相关信息）。以产品实际采集情况为准。
      </div>
      <div class="main--content">
        概要:设备信息是指设备标识符、网络接入信息、设备传感器等等，设备信息在手机终端中可能被表述为"电话信息"，这不代表APP会收集通讯录内容或您主动输入的隐私信息。
      </div>
      <div class="main--content">
        使用目的:设备信息通常用在反作弊和判断账号是否处于安全的环境中。
      </div>
      <div class="main--content">
        特别说明:目前多数手机终端厂商已经支持对设备标识符的更改，以保障您对个人信息的控制权，具体撤回的途径和方式可以参见您所使用的终端设备说明。
      </div>

      <div class="main--content--title">二、个人信息的使用、管理</div>
      <div class="main--content--title">2.1个人信息的使用</div>
      <div class="main--content">
        为了向您提供更好的服务或产品，本产品会在下述情形使用您的个人信息：
      </div>
      <div class="main--content--title">（1）基于法律规定及服务需要</div>
      <div class="main--content">
        我们根据相关法律法规、法律程序的要求；以及根据本产品相关服务条款、应用许可使用协议或其他类似文件的约定；基于提供各项业务功能与服务的需要，使用您的个人信息。
      </div>
      <div class="main--content--title">（2）改善服务</div>
      <div class="main--content">
        根据您使用我们产品的情况、产品运行情况、服务安全保障需要，在不泄露您的个人信息前提下，提升、改善本产品服务。
      </div>
      <div class="main--content--title">三、对Cookie和同类技术的使用</div>
      <div class="main--content">
        为保障产品正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。Cookie可以帮助我们辨认注册用户、计算用户数量、分析页面设计和广告的有效性，也可以省去您输入重复信息的步骤。您可以通过对浏览器进行配置等方式对Cookie进行管理、删除（大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝
        Cookies）。您进行管理、删除Cookie的操作后，可能会影响到您访问本产品或不能充分取得本产品的服务。
      </div>
      <div class="main--content">
        除 Cookie
        外，我们有可能根据产品的实际需要使用同类技术。我们对Cookie和同类技术的研究和使用主要是用于提升服务/产品质量及优化用户体验，不会超出本《用户协议与隐私政策》所述用途。
      </div>

      <div class="main--content--title">四、个人信息的保护</div>
      <div class="main--content--title">4.1保障措施</div>
      <div class="main--content">
        本产品将在现有技术水平条件下，尽一切合理努力保护其获得您的个人信息。为防止您的个人信息在意外的、未经授权的情况下被非法访问、复制、修改、传送、遗失、破坏、处理或使用。我们使用多方位的安全保护措施（包括技术保护手段、管理制度措施等），以确保您的个人信息保护处理合理的安全水平。
      </div>
      <div class="main--content">
        我们并将不断完善相关管理制度，同步建立相关流程和组织，以进一步保护您的个人信息，防止您的个人信息被未经授权的人员擅自访问、使用或披露。我们会严格限制访问信息的人员范围，并与前述人员签署保密协议，违反保密义务的人员将会根据管理制度规定进行处罚。
      </div>

      <div class="main--content--title">4.2安全事件处理</div>
      <div class="main--content">
        如发生个人信息安全事件，我们将按照法律法规的要求，通过公告、推送通知、您预留的联系方式中的一种或多种措施，及时向您告知安全事件的基本情况、处理进程等信息，以尽量减少您的损失或对您的损失进行补救。
      </div>
      <div class="main--content--title">4.3安全建议</div>
      <div class="main--content">
        尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但受限于现有技术限制等，本产品仍然无法保证您的个人信息通过不安全途径或非我们可以控制的环节进行交流时的安全性。因此，建议您采取积极措施保证个人信息的安全，如：设置复杂密码、定期修改账号密码，不将自己的账号密码等个人信息透露给他人等。您在向本产品以外的网站提交个人信息时应尽量避免提供个人敏感信息，并审慎决定。如果您发现自己的个人信息泄密，尤其是您的账号密码发生泄露，请您立即根据本用户协议与隐私政策中提供的联系方式联络我们，以便我们采取相应措施。
      </div>
      <div class="main--content--title">五、本《隐私政策》的适用及修改</div>
      <div class="main--content">
        本《隐私政策》的内容可能会因我们的业务功能变化、个人信息使用目的变更、个人信息保护负责人的联络方式变更等情况发生变更，一旦内容发生变动，我们将会在页面上展示修改之后的《用户协议与隐私政策》，或通过您预留的方式，或通过弹窗或让您重新签署等适当方式通知您；前述通知行为将视为我们已经通知您修改内容。
        如果您不同意我们对本《用户协议与隐私政策》相关条款所做的修改，您有权停止使用本产品。
      </div>
      <div class="main--content--title">六、联系我们</div>
      <div class="main--content">
        如您对本《隐私政策》有任何意见或建议，或就您的个人信息访问、修改等事宜有任何意见、建议或投诉可通过下述方式联系我们。
      </div>
      <div class="main--content">
        我们的常用办公地址：浙江省杭州市西湖区华星发展大厦A633
      </div>
      <div class="main--content">我们的联系方式：13666681552</div>
    </div>
    <!-- <div v-for="(item, index) in list" :key="index">
            <div class="main--content--title">{{
              item.title
            }}</div>
            <div
              class="main--content"
              v-for="(cont, i) in item.content"
              :key="i"
            >
              {{ cont.text }}
            </div>
          </div> -->
    <div style="height: 50rpx"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.main {
  margin: 30px 25px;
  &--header {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #a4acff;
    line-height: 37px;
    margin-bottom: 8px;
    text-align: center;
  }

  &--content {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 32px;
    margin-bottom: 5px;

    &--title {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      line-height: 36px;
      margin: 5px 0;
    }
  }
}
</style>
